import StringMask from 'string-mask';

import { NsInputter } from 'components/common/ns-inputter/NsInputter';
import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import { NsInput } from 'components/common/ns-input/NsInput';
import NsInputterEvent from '../ns-inputter/NsInputterEvent';

type NsSortCodeInputProps = {
  id?: string;
  name?: string;
  label?: string;
  onChange?: (event: NsInputterEvent) => void;
  value?: string;
  inputAttributes?: Record<string, string | boolean>;
};

export const NsSortCodeInput = ({
  id = 'sortcodeField',
  name = 'sortcodeField',
  label = 'Sort code',
  value,
  onChange,
  inputAttributes = {}
}: NsSortCodeInputProps) => {
  const validations = [
    NsInputterValidations.isRequired,
    NsInputterValidations.isInteger,
    NsInputterValidations.minLength(6)
  ];
  const mask = '00-00-00';
  const maskFormater = new StringMask(mask);
  const maskedValue = maskFormater.apply(value);

  return (
    <NsInputter
      validation={validations}
      value={maskedValue}
      name={name}
      mask={mask}
      separator="-"
      ignoreseparator
      onChange={onChange}
    >
      <NsInput
        label={label}
        name={name}
        id={id}
        inputAttributes={inputAttributes}
      />
    </NsInputter>
  );
};
